import { useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button, Input, TextField } from '@zep/ui';
import { ErrorStatus } from '../../../../consts';
import { useCheckPaymentPermission } from '../../../../services';
import { BusinessPayment } from '../../../../types/PaymentTypes';
import { BusinessPaymentLayout } from '../BusinessPaymentLayout';
import S from '../BusinessPayments.module.scss';
export const ConfirmBusinessEmail = ({
  businessName,
  paymentHashId,
  isInvalidEmail,
  onInvalidPage,
  onSetPaymentInfo
}: {
  paymentHashId: string;
  businessName: string;
  isInvalidEmail: boolean;
  onInvalidPage: () => void;
  onSetPaymentInfo: (payment: BusinessPayment) => void;
}) => {
  const {
    t
  } = useTranslation(['common', 'business']);
  const router = useRouter();
  const [error, setError] = useState(false);
  const [email, setEmail] = useState('');
  const {
    mutateAsync
  } = useCheckPaymentPermission();
  const handleCheck = async () => {
    if (!email) {
      return;
    }
    try {
      const data = await mutateAsync({
        email,
        businessPaymentHashId: paymentHashId
      });
      onSetPaymentInfo(data.businessPayment);
    } catch (e) {
      // @ts-ignore
      if (e.status === ErrorStatus.FINISHED_PAYMENT) {
        await router.push(`/business/payments/${paymentHashId}/success?email=${email}`);
        return;
      }

      // @ts-ignore
      if (e.status === ErrorStatus.DISABLED_PAYMENT) {
        onInvalidPage();
      } else {
        setError(true);
        setEmail('');
      }
    }
  };
  return <BusinessPaymentLayout isCenter={true} title={''} data-sentry-element="BusinessPaymentLayout" data-sentry-component="ConfirmBusinessEmail" data-sentry-source-file="ConfirmBusinessEmail.tsx">
      <div className={S.checker_wrapper}>
        <h4 className={S.checker_business_name}>{businessName}</h4>
        <div className={S.checker_email_description}>
          {t('business:business_payments_enter_email')}
        </div>
        <TextField error={isInvalidEmail || error} helperText={(isInvalidEmail || error) && t('business:business_payments_email_invalid')} data-sentry-element="TextField" data-sentry-source-file="ConfirmBusinessEmail.tsx">
          <Input value={email} onChange={e => setEmail(e.currentTarget.value)} onKeyDown={e => {
          if (e.key === 'Enter') {
            handleCheck();
          }
        }} placeholder={t('business:business_payments_email_placeholder')} isFullWidth data-sentry-element="Input" data-sentry-source-file="ConfirmBusinessEmail.tsx" />
        </TextField>
        <Button className={S.checker_confirm_button} size="lg" isFullWidth onClick={handleCheck} data-sentry-element="Button" data-sentry-source-file="ConfirmBusinessEmail.tsx">
          {t('common:confirm')}
        </Button>
      </div>
    </BusinessPaymentLayout>;
};